const $get_username = function (user) {
  let name = user?.profile?.name ?? ''
  name += ' '
  name += user?.profile?.lastName ?? ''

  name.trim()

  return name
}

const plugin = {
  install: (app, options) => {
    app.config.globalProperties.$get_username = $get_username
    app.provide('$get_username', { $get_username })
  }
}

export default plugin
